// extracted by mini-css-extract-plugin
export default {"cookieConsentFlow":"cookie-consent-flow-wrapper_cookieConsentFlow__Tpqfg"};